const GeneratedOutput = ({ text }) => {
  return (
    <div style={{ 
      height: "100%", 
      display: "flex", 
      flexDirection: "column",
      overflow: "hidden" // Prevent double scrollbars
    }}>
      <div style={{ 
        padding: "8px 12px", 
        backgroundColor: "#f8f9fa", 
        borderBottom: "1px solid #dee2e6",
        fontSize: "14px",
        fontWeight: "500",
        color: "#495057",
        flexShrink: 0 // Don't shrink the header
      }}>
        📬 Generierte Nachricht
      </div>
      <div style={{
        flex: "1",
        overflow: "auto", // This allows the content to scroll
        padding: "12px 12px 24px 12px", // Added bottom padding
        backgroundColor: "#ffffff"
      }}>
        <pre style={{
          whiteSpace: "pre-wrap",
          fontSize: "13px",
          lineHeight: "1.5",
          margin: "0",
          fontFamily: "system-ui, -apple-system, sans-serif",
          color: "#333",
          wordWrap: "break-word"
        }}>
          {text}
        </pre>
      </div>
    </div>
  );
};

export default GeneratedOutput;
